export const getInsuranceUrl = (user) => {
  const userId = user?._id || user?.id;
  let userDataValue = "Garaaz";
  if (userId) {
    try {
      userDataValue = encodeURIComponent(userId);
    } catch (error) {
      userDataValue = "Garaaz";
    }
  }
  return `https://pos.squareinsurance.in/reference?data=F9oXFV0GNGt9NGBeBDwoymJ=&user_data=${userDataValue}`;
};
